import { Flag } from '@weave/schema-gen-ts/dist/schemas/feature-flags/feature_flags_types.pb';
import { useQuery, useQueryClient } from 'react-query';
import { useLocationService } from '@frontend/wam-location-service';
import { theme } from '@frontend/theme';
import { Modal, ModalControlModalProps, Text } from '@frontend/design-system';
import { getLocationsWithFlag, useDeleteFlagMutation } from '../queries';

type Props = {
  modalProps: ModalControlModalProps;
  flag?: Flag;
};

export const DeleteFlagModal = ({ modalProps, flag }: Props) => {
  const { currentLocationId: locationId } = useLocationService();
  const queryClient = useQueryClient();

  const { data: locationsWithFlag } = useQuery({
    queryKey: ['locations-with-flag', flag?.name],
    queryFn: () => getLocationsWithFlag({ flagName: flag?.name ?? '', value: true }),
    enabled: !!flag?.name,
  });

  const { mutate: deleteFlag } = useDeleteFlagMutation({
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries([locationId, 'location-feature-flags']);
        queryClient.invalidateQueries(['feature-flags']);
        queryClient.invalidateQueries(['locations-with-flag']);
        modalProps.onClose();
      },
    },
  });

  return (
    <Modal {...modalProps} minWidth={600}>
      <Modal.Header onClose={modalProps.onClose}>{'Delete Feature Flag'}</Modal.Header>
      <Modal.Body css={{ paddingTop: theme.spacing(2) }}>
        <Text>
          {locationsWithFlag?.locationIds?.length ?? 0} Locations have this flag set, are you sure you want to delete
          it?
        </Text>
      </Modal.Body>
      <Modal.Footer
        primary={{
          label: 'Delete Flag',
          onClick: () => deleteFlag({ flagName: flag?.name }),
          destructive: true,
        }}
        secondary={{
          label: 'Cancel',
          onClick: modalProps.onClose,
        }}
      />
    </Modal>
  );
};
